<template>
  <footer class="row">
    <div class="col-md-4">
      <h3 class="">Fiber</h3>
      <p>
        With Fiber, you can setup your own personal portfolio in minutes with
        dozens of premade beautiful templates.
      </p>
      <p>MAde with love in the Netherlands.</p>
    </div>
    <div class="col-md-8">
      <div class="row row-cols-2">
        <div class="col-lg-3">
          <h3 class="text-black">Sitemap</h3>
          <ul class="nav flex-column">
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Homepage</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Pricing</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Testimonials</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3">
          <h3 class="text-black">Resources</h3>
          <ul class="list-unstyled">
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Support</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Contact</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">FAQ</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3">
          <h3 class="text-black">Company</h3>
          <ul class="list-unstyled">
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">About</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Customers</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Blog</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3">
          <h3 class="text-black">Company</h3>
          <ul class="list-unstyled">
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Sarah Andrews</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Mathew Higgins</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link text-dark">Janice Dave</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style></style>
